import { useState, useEffect } from 'react'

function useDebounce<T>(value: T, timeOut = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, timeOut)

    return () => {
      clearTimeout(handler)
    }
  }, [value, timeOut])

  return debouncedValue
}

export default useDebounce
